import "./styles.css";
import { FC} from "react";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { Contacts } from "../../../../../shared/interfaces/contacts";
import { ViewContainer } from "../../../../../shared/components/viewContainer";
import SingleEntityContainer from "../../../../../shared/components/singleEntityContainer";
import { TitleBarProps } from "../../../../../shared/components/titleBar";
import { getContactTextFields } from "../../variables/textFields";
import { CloseButton } from "../../../../../shared/components/closeButton";

interface ContactViewProps {
  id: string;
  onClose: () => void;
}
const ContactView: FC<ContactViewProps> = ({ id, onClose }) => {
  const { loading, data } = useQuery(
    `/admin/organization-contacts/${id}`,
    null
  );
  const contactsData: Contacts = (data as any)?.data || {};
  const adminEditFields = getContactTextFields(contactsData);
  const viewTitleBar: TitleBarProps = {
    title: "Contact Details",
    headerTitle: "Contact Details",
  };
  const adminEditTooltipNode = (<>
    <CloseButton onClick={() => onClose()} />
  </>);

  return (
    <>
        <ViewContainer
          loading={loading}
          titleBar={viewTitleBar}
        >
          <div className="entity-container">
            <SingleEntityContainer
              entityFields={adminEditFields}
              tooltips={adminEditTooltipNode}
            ></SingleEntityContainer>
          </div>
        </ViewContainer >
    </>
  );
};

export default ContactView;
